import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import ActionLink from '@/components/UI/ActionLink';
import conv from '@/public/svg/conv.svg';
import mapMarker from '@/public/svg/map-marker-green.svg';

const arrow = <FaArrowRight className="h-3 w-3" aria-hidden="true" />;

const HomeIntro: React.FC = () => (
    <section className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-4 text-textColor">
        <div className="flex gap-4 rounded-2xl bg-secondaryLight p-5 xl:flex-col xl:gap-3 xl:p-4">
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-white">
                <img src={conv} alt="" className="h-7 w-7" />
            </span>
            <div>
                <h2 className="text-lg font-bold">Was fehlt dir im Regal?</h2>
                <p className="text-sm leading-relaxed">Sag uns, was du dir in deinem Yobsti wünschst.</p>
                <div className="mt-3">
                    <ActionLink size="sm" to="/fuer-kunden#feedback" event="cta-click" eventData={{ target: 'product-wish', location: 'home' }}>Produkt wünschen {arrow}</ActionLink>
                </div>
            </div>
        </div>

        <div className="flex gap-4 rounded-2xl bg-primaryLight p-5 xl:flex-col xl:gap-3 xl:p-4">
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-white">
                <img src={mapMarker} alt="" className="h-7 w-7" />
            </span>
            <div>
                <h2 className="text-lg font-bold">Dein Einkauf beginnt um die Ecke.</h2>
                <p className="text-sm leading-relaxed">Finde deinen Markt und seine Öffnungszeiten.</p>
                <div className="mt-3">
                    <ActionLink size="sm" to="/standorte" variant="solid" event="cta-click" eventData={{ target: 'find-store', location: 'home' }}>Standort finden {arrow}</ActionLink>
                </div>
            </div>
        </div>
    </section>
);

export default HomeIntro;
